import { App, useTokenSignInMutation } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import GfTokenSignInProvider from '@/gf/providers/TokenSignInProvider'

const TokenSignInProvider = ({ children }: { children: React.ReactNode }) => {
  const [tokenSignIn] = useTokenSignInMutation({ client: useGqlClient() })
  const signIn = (token: string) => tokenSignIn({ variables: { app: App.PartsHub, token } })

  return <GfTokenSignInProvider signIn={signIn}>{children}</GfTokenSignInProvider>
}

export default TokenSignInProvider
